module.exports = __webpack_public_path__ + "img/contact-melvinbornegrim.81c5d66e.png";